<div
    (click)="onClick(notification, $event)"
    (keydown.enter)="onClick(notification)"
    role="button" tabindex="0"
    [class]="'p-3 mb-2 border-l-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 ' + isRead(notification.isRead)"
    >
    <div class="flex justify-between items-center mb-2">
        <div class="flex items-center justify-start gap-1">
            <span class="font-bold text-md truncate">{{ notification.title }}</span>
            <span class="text-xs font-thin">{{ formatDate(notification.createdAt) }}</span>
        </div>
        <button type="button" class="layout-topbar-action" (click)="onDelete($event, notification.id)">
            <span class="text-red-500"><i class="pi pi-trash"></i></span>
        </button>
    </div>
    <div class="text-xs text-gray-600 dark:text-gray-400">{{ notification.message }}</div>
</div>
